module.exports = __webpack_public_path__ + "assets/img/tenExtract.3bcbe9e9.png";